// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"34c13bd2","651":"e4eb2914"}[chunkId] + ".chunk.js";
};